import { render } from "./PageHeadline.vue?vue&type=template&id=7fea17cc"
import script from "./PageHeadline.vue?vue&type=script&lang=js"
export * from "./PageHeadline.vue?vue&type=script&lang=js"

import exportComponent from "E:\\_projekte\\PRIGNITZMUSEUM_HAVELBERG\\ARCHITEKTURSPUR\\release\\architekturspur\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__